<template>
  <div class="modal modal-tentative-form fade fixed-end" tabindex="-1" role="dialog">
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">Add Tentative Entry</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Name</label>
            <input
              name="name"
              v-model="form.name"
              type="text"
              class="form-control"
              :class="errorClass('name')"
              v-validate="'required'"
              data-vv-name="name"
            />
            <help-block field="name" />
          </div>

          <div class="mb-3">
            <label class="control-label">Group</label>
            <multiselect
              :show-labels="false"
              v-model="form.group"
              :options="groups"
              :class="errorClass('group')"
              v-validate="'required'"
              data-vv-name="group"
            ></multiselect>
            <help-block field="group" />
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-bs-dismiss="modal">
            Cancel
          </button>
          <ladda-button :on-click="save" class="btn btn-primary"
            >Save</ladda-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CModal } from "@chameleon/chameleon-vue";
import Multiselect from "vue-multiselect";
import { LaddaButton } from "components/form/input";
import { notify } from "utils";

export default {
  $_veeValidate: {
    validator: "new",
  },
  extends: CModal,
  components: { Multiselect, LaddaButton },

  data() {
    return {
      form: { name: "", group: null },
      groups: ["Opportunity", "SLA", "Retainer", "DevOps", "Hosting"],
    };
  },

  mounted() {
    this.addEventListener("open", () => {
      this.form = { name: "", group: null };
      this.$validator.reset();
    });
  },

  methods: {
    async save() {
      if (!(await this._validate())) {
        return Promise.reject();
      }

      return this.$store
        .dispatch("forecast/addTentativeRow", this.form)
        .then(() => {
          notify.success("Tentative entry added.");
          this.close();
        });
    },
  },
};
</script>